// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"1839cbec3cbcde700dae","655":"67f04aeb30776c68481d"}[chunkId] + ".js";
};